module.exports = __webpack_public_path__ + "img/SM.ccf99e9b.png";